/**
 * Получить идентификатор страны по коду
 * @param countryCode код страны (RU, BLR)
 * @returns {number}
 */
export default function getCountryIdByCode(countryCode) {
  // Если не передан, возвращаем 1
  if (!countryCode || countryCode === 'RU') {
    return 1;
  }
  return 19;
}
